<template>
    <div class="form-group" style="min-width: 50%">
        <label v-if="label" :for="name + type">{{ label }}</label>
        <select
            v-bind="$attrs"
            @change="$emit('input', $event.target.value)"
            v-bind:value="value"
            class="form-control"
            :id="name + type"
        >
            <option>Please select</option>
            <option
                v-for="item in selectOptions"
                :key="item.value"
                :value="item.value"
            >
                {{ item.displayName }}
            </option>
        </select>
    </div>
</template>

<script>
import { enumerations } from "../config/data.js";

export default {
    name: "Select",
    inheritAttrs: false,
    props: {
        label: String,
        type: String,
        items: String,
        name: String,
        value: [String, Boolean, Array, Object, Number],
        list: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            listValue: enumerations,
        };
    },
    computed: {
        selectOptions() {
            const list = this.listValue[this.type];
            if (list) {
                return this.listValue[this.type][this.items] ?? [];
            }
            const options = {};
            const allOptions = Object.entries(this.listValue).forEach((el) => {
                Object.entries(el[1]).forEach(([key, val]) => {
                    if (!Object.hasOwnProperty.call(options, key)) {
                        options[key] = val;
                    }
                });
            });
            const ol = options[this.items];
            if (ol) {
                return ol;
            }
            return [];
        },
    },
};
</script>

<style>
</style>